const components = [
  // Compontentes de perfil
  { name: "vc-simulator", component: "commons/VSimulator.vue" },
  { name: "vc-color-banner", component: "commons/VColorBanner.vue" },
  { name: "vc-white-banner", component: "commons/VWhiteBanner.vue" },
  { name: "vc-contact", component: "VContact.vue" },
  { name: "vc-politic", component: "VPolitic.vue" },
  { name: "vc-footer", component: "commons/VFooter.vue" },
  { name: "vc-simubanner", component: "commons/VSimubanner.vue" },
  { name: "vc-politic-banner", component: "commons/VPoliticbanner.vue" },
  { name: "vc-expansion", component: "VExpansion.vue" },
  { name: "vc-requirements-personal", component: "VRequirementsPersonal.vue" },
  { name: "vc-requirements-mipyme", component: "VRequirementsMIPYME.vue" },
  { name: "vc-expansion-car", component: "VExpansioncar.vue" },
  {
    name: "vc-simulator-credit-personal",
    component: "commons/VSimulatorCreditPersonal.vue",
  },
  {
    name: "vc-simubanner-credit-personal",
    component: "commons/VSimubannerCreditPersonal.vue",
  },
  {
    name: "vc-simulator-credit-mipyme",
    component: "commons/VSimulatorCreditMipyme.vue",
  },
  {
    name: "vc-simubanner-credit-mipyme",
    component: "commons/VSimubannerCreditMipyme.vue",
  },
  {
    name: "vc-simulator-credit-pyme",
    component: "commons/VSimulatorCreditPyme.vue",
  },
  {
    name: "vc-simubanner-credit-pyme",
    component: "commons/VSimubannerCreditPyme.vue",
  },
  {
    name: "vc-simulator-credit-car",
    component: "commons/VSimulatorCreditCar.vue",
  },
  {
    name: "vc-simubanner-credit-car",
    component: "commons/VSimubannerCreditCar.vue",
  },
  { name: "vc-sucursales", component: "VSucursales.vue" },
  { name: "vc-modal", component: "VModal.vue" },
  { name: "vc-mision", component: "commons/VMision.vue" },
  { name: "vc-valores", component: "commons/VValores.vue" },
  { name: "vc-request-modal", component: "Request-Credit.vue" },
];

export { components };
